import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

class AccordionCustom extends HTMLElement {
  /** @returns {HTMLDetailsElement | null} */
  get details() {
    const details = this.querySelector('details');
    return details instanceof HTMLDetailsElement ? details : null;
  }

  /** @returns {HTMLElement | null} */
  get summary() {
    const details = this.details;
    if (!details) return null;

    const summary = details.querySelector('summary');
    return summary instanceof HTMLElement ? summary : null;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    const details = this.details;
    const summary = this.summary;

    if (!details || !summary) return;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    summary.addEventListener('click', this.handleClick, { signal });
    details.addEventListener('toggle', this.#handleToggle, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
    }
  };

  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  #setDefaultOpenState() {
    const details = this.details;
    if (!details) return;

    const isMobile = isMobileBreakpoint();

    details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  #handleKeyDown = (event) => {
    const details = this.details;
    const summary = this.summary;

    if (!details || !summary) return;

    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();
      details.open = false;
      summary.focus();
    }
  };

  
   #handleToggle = () => {
    if (this.hasAttribute('data-keep-open')) return;

    const currentDetails = this.details;

    if (!currentDetails || !currentDetails.open) return;

    document.querySelectorAll('accordion-custom').forEach((accordion) => {
      if (!(accordion instanceof AccordionCustom) || accordion === this) return;
      if (accordion.hasAttribute('data-keep-open')) return;

      const details = accordion.details;
      if (!details) return;

      details.open = false;
    });
  };
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}